import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as httpClient from "../../util/httpClient";
import * as PasswordManagerAction from "../../store/passwordManagerService/actions";
import { Notification } from "../common/Notification";
import { useTranslation } from "react-i18next";

const ConfirmDeletePassword = (props: any) => {
    const dispatch = useDispatch();
    const requestRequestPasswordList = () => dispatch(PasswordManagerAction.actionCreators.requestRequestPasswordList());
    const passwordRecordExtId = useSelector((state: ApplicationState) => state.passwordManagerState && state.passwordManagerState.selectedPasswordRecordExtId);
    const [isSaving, setisSaving] = useState(false);
    const { t: tLang } = useTranslation();

    useEffect(() => {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    const deletePassword = () => {
        const requestBody = {
            recordExtId: passwordRecordExtId,
        };
        setisSaving(true);
        httpClient
            .sendRequest("POST", `api/securepassword/deletePassword`, requestBody)
            .then((data) => {
                if (data.isSuccess) {
                    requestRequestPasswordList();
                    Notification({
                        type: "success",
                        title: tLang("identityVault.passwordManager.addEditPassword.successText"),
                        message: tLang("identityVault.passwordManager.addEditPassword.passwordDeletedMessage"),
                        duration: 5,
                    });
                    setisSaving(false);
                    props.closeEditPasswordDialog();
                    closeDialog();
                } else {
                    setisSaving(false);
                    Notification({
                        type: "error",
                        title: tLang("identityVault.passwordManager.addEditPassword.errorText"),
                        message: tLang("identityVault.passwordManager.addEditPassword.deletePasswordFailedMessage"),
                        duration: 5,
                    });
                }
            })
            .catch(function (error) {
                setisSaving(false);
                Notification({
                    type: "error",
                    title: tLang("identityVault.passwordManager.addEditPassword.errorText"),
                    message: tLang("identityVault.passwordManager.addEditPassword.deletePasswordFailedMessage"),
                    duration: 5,
                });
            });
    };

    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon status-default">
                    <em className="las la-trash-alt"></em>
                </div>
                <h1>{tLang("identityVault.passwordManager.addEditPassword.confirmDelete")}</h1>
            </div>
            <div className={isSaving ? "dialog-body loading" : "dialog-body"}>
                <p>{tLang("identityVault.passwordManager.addEditPassword.confirmMessage")}</p>
            </div>
            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-link btn-no-padding btn-no-border"
                            onClick={() => {
                                props.closeDialog();
                                window.addToDataLayer({ event: "Cancel Deleting Password" });
                            }}
                        >
                            <span className="btn-text">{tLang("identityVault.passwordManager.addEditPassword.cancelBtnText")}</span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-red"
                            onClick={() => {
                                deletePassword();
                                window.addToDataLayer({ event: "Confirm Password Delete" });
                            }}
                        >
                            <span className="btn-icon">
                                <em className="las la-trash-alt"></em>
                            </span>
                            <span className="btn-text">{tLang("identityVault.passwordManager.addEditPassword.deleteBtn")}</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ConfirmDeletePassword;
